import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cloneObj } from '@nu-art/ts-common';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/components/Layouts/Layouts';
import { SimpleListAdapter } from '@nu-art/thunderstorm-frontend/components/adapter/Adapter';
import { QRangeInput } from '@app/hcs-frontend';
import { ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, } from '@nu-art/thunderstorm-frontend/index';
export class Component_PrevalenceEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const propPrevalence = nextProps.prevalence ? cloneObj(nextProps.prevalence) : undefined;
        state.prevalence = state.prevalence || propPrevalence ? [propPrevalence[0] * 100, propPrevalence[1] * 100] : undefined;
        return state;
    }
    updateProfilePrevalence = (prevalence) => {
        this.logInfo(prevalence);
        if (!prevalence) {
            this.deletePrevalence();
            return;
        }
        const normalizePrevalenceValue = (value) => {
            value = Math.min(value, 100);
            value = Math.max(value, 0);
            return value;
        };
        if (prevalence) {
            prevalence[0] = normalizePrevalenceValue(prevalence[0]);
            prevalence[1] = normalizePrevalenceValue(prevalence[1]);
            this.setState({ prevalence }, () => {
                this.props.onChanged([normalizePrevalenceValue(prevalence[0] / 100), normalizePrevalenceValue(prevalence[1] / 100)]);
            });
        }
    };
    deletePrevalence = () => {
        this.props.onChanged(undefined);
        this.setState({ prevalence: undefined });
    };
    renderInput = () => {
        if (this.props.disableEdit)
            return this.state.prevalence ? _jsxs("div", { children: [this.state.prevalence[0], " - ", this.state.prevalence[0]] }) : '';
        return _jsx(QRangeInput, { placeholder: 'Range between 0-100', value: this.state.prevalence ? [+this.state.prevalence[0].toFixed(2), +this.state.prevalence[1].toFixed(2)] : undefined, onValueBlur: val => this.updateProfilePrevalence(val) });
    };
    render() {
        return _jsx(LL_V_L, { className: 'match_width', onContextMenu: (e) => {
                if (this.props.disableEdit)
                    return;
                const menuItems = [
                    { label: 'Remove', onClick: () => this.deletePrevalence() },
                ];
                const rightClickMenu = {
                    id: 'prognosis-right-click-menu',
                    adapter: SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label })),
                    originPos: { y: e.clientY, x: e.clientX, },
                    modalPos: { x: 0, y: 1 },
                    onNodeClicked: (path, item) => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        item.onClick?.();
                    }
                };
                ModuleFE_MouseInteractivity.showMenu(rightClickMenu);
            }, children: this.renderInput() });
    }
}
//# sourceMappingURL=Component_PrevalenceEditor.js.map